//Vanila JS plugin boilerplate
//ref; https://github.com/ccurtin/vanilla-js-plugin-boilerplate/blob/basic-template/index.js
(function (root, factory) {
  var pluginName = 'bsAlert';

  if (typeof define === 'function' && define.amd) {
    define([], factory(pluginName));
  } else if (typeof exports === 'object') {
    module.exports = factory(pluginName);
  } else {
    root[pluginName] = factory(pluginName);
  }
})(this, function (pluginName) {
  var possibleAlertTypes = ['info', 'success', 'error'];
  var baseClass = 'bs-alert';
  var alertTopClass = baseClass + '-top';

  var defaults = {
    closeLabel: 'Close',
    cssClass: [],
    removeOld: true,
    overlap: false,
    showClose: true,
    showIcon: false,
    alertType: 'info', //info, success, error
    timeout: 5000,
    htmlMessage: false,
  };

  /**
   * Merge defaults with user options
   * @param {Object} defaults Default settings
   * @param {Object} options User options
   */
  var extend = function (target, options) {
    var prop,
      extended = {};
    for (prop in defaults) {
      if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
        extended[prop] = defaults[prop];
      }
    }
    for (prop in options) {
      if (Object.prototype.hasOwnProperty.call(options, prop)) {
        extended[prop] = options[prop];
      }
    }
    return extended;
  };

  /**
   * validate text exists Functions
   @private
   */
  function validateText(text) {
    return typeof text === 'undefined' || text.length < 1 ? false : true;
  }

  function getAlertClasses(options) {
    var classes = [baseClass, baseClass + '-' + getValidType(options.alertType), alertTopClass];
    return classes.join(' ');
  }

  function getValidType(type) {
    //check if the type is valid
    if (typeof type !== 'undefined' && possibleAlertTypes.indexOf(type) === -1) {
      return possibleAlertTypes[0];
    }
    return type;
  }

  /**
   * Plugin Object
   * @param {Object} options User options
   * @constructor
   */
  function Plugin(options) {
    this.options = extend(defaults, options);

    if (!validateText(options.text)) {
      return;
    }

    this.init(); // Initialization Code Here
  }

  /**
   * Plugin prototype
   * @public
   * @constructor
   */
  Plugin.prototype = {
    init: function () {
      var messageElement = document.createElement('p');
      messageElement.className = 'bs-alert-text';

      if (this.options.htmlMessage) {
        messageElement.innerHTML = this.options.text;
      } else {
        messageElement.innerText = this.options.text;
      }

      var alertElement = document.createElement('div');
      alertElement.className = getAlertClasses(this.options);
      alertElement.appendChild(messageElement);

      if (this.options.showClose) {
        var closeElement = document.createElement('a');
        closeElement.setAttribute('href', 'javascript:void(0);');
        closeElement.className = 'bs-alert-close';
        closeElement.innerText = this.options.closeLabel;
        alertElement.appendChild(closeElement);

        closeElement.addEventListener(
          'click',
          function (evt) {
            evt.preventDefault();
            this.parentElement.classList.add(alertTopClass);
          },
          false
        );
      }

      if (this.options.showIcon && !this.options.showClose) {
        var closeElement = document.createElement('a');
        closeElement.setAttribute('href', 'javascript:void(0);');
        closeElement.className = 'bs-alert-close-icon';
        alertElement.appendChild(closeElement);
        closeElement.closest('.bs-alert').classList.add('bs-alert--var');

        closeElement.addEventListener(
          'click',
          function (evt) {
            evt.preventDefault();
            this.parentElement.classList.add(alertTopClass);
          },
          false
        );
      }

      //remove exist alertbox
      if (this.options.removeOld) {
        var closeAlerts = document.querySelectorAll('.bs-alert');
        for (var i = 0; i < closeAlerts.length; i++) {
          closeAlerts[i].remove();
        }
      }

      //show alert
      document.body.appendChild(alertElement);
      setTimeout(function () {
        alertElement.classList.remove(alertTopClass);
      }, 50);

      //hide alert after timeout
      setTimeout(function () {
        alertElement.classList.add(alertTopClass);
      }, this.options.timeout);
    }, // #! init
  };
  return Plugin;
});
